import { render, staticRenderFns } from "./PrescriptionItemRadioSelect.vue?vue&type=template&id=ccecef46&scoped=true"
import script from "./PrescriptionItemRadioSelect.vue?vue&type=script&lang=ts"
export * from "./PrescriptionItemRadioSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccecef46",
  null
  
)

export default component.exports